import configure from "configure"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import React, { useEffect, useMemo, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import { fetchNodeData } from "utils/common-fetchData";
import { developmentProjectType, ResourceType } from "utils/common-options"

const OverviewOnboarding = ({ stageData }) => {
    const [isLoading, setLoading] = useState(false)
    const toggleLoading = (loading) => {
        setLoading(loading)
    }
    const [projectDetail, setProjectDetail] = useState({})
    const token = secureLocalStorage.getItem('auth_token')
    const fetchProjects = async () => {
        const res = await fetchNodeData(
            toggleLoading,
            `projectView/${stageData?.project_id}`,
            token
        )
        if (res?.success) {
            const projects = res?.data?.project[0]
            setProjectDetail(projects)
        }
    }
    const [datas, setDatas] = useState([])
    const getprojectNotes = async () => {
        const res = await fetchNodeData(setLoading, `projectNotes/${stageData?.project_id}`, token);
        if (res?.success) {
            setDatas(res?.data?.notes)

        }
    }
    useEffect(() => {
        fetchProjects()
        getprojectNotes()
    }, [])


    return (
        <div>
            {isLoading && (<Loader />)}
            {/* <div className="row">
                <div className="col-lg-8">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex">
                                <div className="flex-grow-1 overflow-hidden">
                                    <h5 className="text-purple fw-bold font-size-18 text-capitalize">
                                        {projectDetails?.project_name}
                                    </h5>
                                    <p>
                                        <strong>Project Type</strong> : {
                                            developmentProjectType?.find(
                                                obj => obj?.value == projectDetails?.project_type
                                            )?.label
                                        } ,{" "}
                                        <strong>Customer</strong> : {projectDetails?.customer}
                                    </p>
                                </div>
                            </div>

                            <div className="d-flex gap-4 mt-2 ">
                                <div className="text-muted  ">
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">Project Belongs</span>{" "}
                                        : {projectDetails?.belongs_to}
                                    </p>
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">Resource Type</span>:{' '}
                                        {ResourceType?.find((obj) => obj?.value == projectDetails?.billingtype)?.label}
                                    </p>
                                </div>
                                <div className="info_box_1"></div>
                                <div className="text-muted ">
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">
                                            Key Account Manager
                                        </span>{" "}
                                        : {projectDetails?.kam_name}
                                    </p>
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">Scrum Master</span>:
                                        {projectDetails?.scrum_mastername}
                                    </p>
                                </div>
                            </div>

                            <div className="task-dates row mt-4">
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar me-1 text-primary"></i> Start
                                            Date
                                        </h5>
                                        <p className="text-muted mb-0">
                                            {moment(projectDetails?.startdate).format(
                                                "DD MMM, YYYY"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                                            Est. End Date
                                        </h5>
                                        <p className="text-muted mb-0"> {moment(projectDetails?.enddate).format(
                                            "DD MMM, YYYY"
                                        ) || "-"}</p>
                                    </div>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                                            Number OF Hours
                                        </h5>
                                        <p className="text-muted mb-0">{projectDetails?.no_of_weeks} Hours</p>
                                    </div>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                                            Delivery Before Date
                                        </h5>
                                        <p className="text-muted mb-0">{moment(projectDetails?.deliverydatebefore).format(
                                            "DD MMM, YYYY"
                                        ) || "-"}</p>
                                    </div>
                                </div>
                            </div>
                            {secureLocalStorage.getItem("auth_role") == 9 ||
                                secureLocalStorage.getItem("auth_role") == 10 ||
                                secureLocalStorage.getItem("auth_role") == 22 ||
                                secureLocalStorage.getItem("auth_role") == 4 ||
                                secureLocalStorage.getItem("auth_role") == 11 ||
                                secureLocalStorage.getItem("auth_role") == 1 ||
                                secureLocalStorage.getItem("auth_role") == 18 ? (
                                <>
                                    <p className="mt-4 pt-3 mb-0">
                                        <span className="text-purple fw-bold">
                                            Payment Schedule
                                        </span>
                                    </p>
                                    <div className="task-dates row ">
                                        {projectDetails?.payment_schedule?.map((obj, i) => {
                                            const dates = projectDetails?.completion_dates?.split(',')[i]
                                            return (
                                                <div className="col-3 col-sm-3" key={i}>
                                                    <div className="mt-3">
                                                        <h5 className="font-size-14">
                                                            <i className="bx bx-calendar me-1 text-primary"></i>{" "}
                                                            {obj}
                                                        </h5>
                                                        <p className="text-muted mb-0">
                                                            {moment(dates).format(
                                                                "DD MMM, YYYY"
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </>
                            ) : null}

                            <h5 className="font-size-15 mt-4">Project Description :</h5>
                            <p className="text-muted" dangerouslySetInnerHTML={{ __html: projectDetails?.description }} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <p className="mb-2 ">
                                <span className="text-purple font-size-18 fw-bold">Hours Distribution</span>
                            </p>
                            <table className="table table-bordered mb-0  table-hover table">
                                <thead className="">
                                    <tr>
                                        <th>Allocation Name</th>
                                        <th className="">Approx %</th>
                                        <th className="text-center col-3">
                                            Hours
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="col-6">Planning</td>
                                        <td>{calculatePercentage(projectDetails?.planning, projectDetails?.total_hrs)} %</td>
                                        <td className="col-2">
                                            <input
                                                required=""
                                                type="text"
                                                placeholder="Hours.."
                                                className="form-control text-center "
                                                name="estimatedtime"
                                                value={projectDetails?.planning}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-6">Designing</td>
                                        <td>{calculatePercentage(projectDetails?.designing, projectDetails?.total_hrs)} %</td>
                                        <td className="col-2">
                                            <input
                                                required=""
                                                type="text"
                                                placeholder="Hours.."
                                                className="form-control text-center "
                                                name="estimatedtime"
                                                value={projectDetails?.designing}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-6">Development </td>
                                        <td>{calculatePercentage(projectDetails?.development, projectDetails?.total_hrs)} %</td>
                                        <td className="col-2">
                                            <input
                                                required=""
                                                type="text"
                                                placeholder="Hours.."
                                                className="form-control text-center "
                                                name="estimatedtime"
                                                value={projectDetails?.development}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-6">Testing </td>
                                        <td>{calculatePercentage(projectDetails?.testing, projectDetails?.total_hrs)} %</td>
                                        <td className="col-2">
                                            <input
                                                required=""
                                                type="text"
                                                placeholder="Hours.."
                                                className="form-control text-center "
                                                name="estimatedtime"
                                                value={projectDetails?.testing}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-6">Deployment </td>
                                        <td>{calculatePercentage(projectDetails?.deployment, projectDetails?.total_hrs)} %</td>
                                        <td className="col-2">
                                            <input
                                                required=""
                                                type="text"
                                                placeholder="Hours.."
                                                className="form-control text-center "
                                                name="estimatedtime"
                                                value={projectDetails?.deployment}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr className="bg-light-purple">
                                        <td className="col-6">
                                            <strong className="text-purple fs-5">Total Hours</strong>
                                        </td>
                                        <td>100 %</td>
                                        <td className="col-2">
                                            <input
                                                required=""
                                                type="text"
                                                placeholder="Hours.."
                                                className="form-control text-center "
                                                name="estimatedtime"
                                                value={projectDetails?.total_hrs}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="row">
                <div className={` col-lg-7`}>
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex">
                                <div className="flex-grow-1 overflow-hidden">
                                    <h5 className="text-purple fw-bold font-size-18">
                                        {projectDetail?.project_name}
                                    </h5>
                                    <p>
                                        <strong>Project Type</strong> :{" "}
                                        {
                                            developmentProjectType.find(
                                                obj => obj.value === projectDetail?.project_type
                                            )?.label
                                        }
                                        , <strong>Customer</strong> :{projectDetail?.customer1}
                                    </p>
                                </div>
                            </div>
                            <h5 className="font-size-15 mt-4">Project Description :</h5>
                            <p
                                className="text-muted"
                                dangerouslySetInnerHTML={{
                                    __html: projectDetail?.description,
                                }}
                            />

                            <div className="d-flex gap-4 mt-5 ">
                                <div className="text-muted  ">
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">
                                            Project Belongs
                                        </span>{" "}
                                        : {projectDetail?.location}
                                    </p>
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">
                                            Resource Type
                                        </span>
                                        :{" "}
                                        {
                                            ResourceType?.find(
                                                obj => obj?.value == projectDetail?.billingtype
                                            )?.label
                                        }
                                    </p>
                                    <p className="mb-0">
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                        <span className="text-purple fw-bold">
                                            Project Industry
                                        </span>{" "}
                                        : {projectDetail?.industry_name}
                                    </p>
                                </div>
                                <div className="info_box_1"></div>
                                <div className="text-muted ">
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">
                                            Key Account Manager
                                        </span>{" "}
                                        : {projectDetail?.kam_name}
                                    </p>
                                    <p>
                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                        <span className="text-purple fw-bold">
                                            Scrum Master
                                        </span>
                                        : {projectDetail?.scrum_mastername}
                                    </p>
                                </div>
                            </div>

                            <div className="task-dates row mt-4">
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar me-1 text-primary"></i>{" "}
                                            Start Date
                                        </h5>
                                        <p className="text-muted mb-0">
                                            {moment(projectDetail?.startdate).format(
                                                "DD MMM, YYYY"
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                                            Est. End Date
                                        </h5>
                                        <p className="text-muted mb-0">
                                            {moment(projectDetail?.enddate).format(
                                                "DD MMM, YYYY"
                                            ) || "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <div className="mt-4">
                                        <h5 className="font-size-14">
                                            <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                                            No. Of Days
                                        </h5>
                                        <p className="text-muted mb-0">45 Days</p>
                                    </div>
                                </div>
                                <div className="col-4 col-sm-3 ps-0">
                                    {projectDetail?.project_type !== 3 && (
                                        <div className="col-4 col-sm-3 ps-0">
                                            <div className="mt-4">
                                                <h5 className="font-size-14">
                                                    <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                                                    Delivery Before Date
                                                </h5>
                                                <p className="text-muted mb-0">
                                                    {moment(projectDetail?.deliverydatebefore).format(
                                                        "DD MMM, YYYY"
                                                    ) || "-"}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p className="mt-4 pt-3 mb-0">
                                <span className="text-purple fw-bold">
                                    Payment Schedule
                                </span>
                            </p>
                            <div className="task-dates row ">
                                {projectDetail?.payment_schedule?.map((obj, i) => {
                                    const dates =
                                        projectDetail?.completion_dates?.split(",")[i]
                                    return (
                                        <div className="col-3 col-sm-3" key={i}>
                                            <div className="mt-3">
                                                <h5 className="font-size-14">
                                                    <i className="bx bx-calendar me-1 text-primary"></i>{" "}
                                                    {obj}
                                                </h5>
                                                <p className="text-muted mb-0">
                                                    {moment(dates).format("DD MMM, YYYY")}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`col-lg-5`}>
                    <div className="card">
                        <div className="card-body" style={{maxHeight:"650px", overflowY:"auto"}}>
                            <div>
                                <h5 className="text-purple fw-bold font-size-18">
                                    Project Notes
                                </h5>
                            </div>
                            <div className="mt-4">
                                <ul className="verti-timeline list-unstyled notes-box">
                                    {datas?.map((note, key) => {
                                        return (
                                            <li key={key} className="event-list position-relative">

                                                <div className="event-timeline-dot">

                                                    <img
                                                        src={`${configure.imgUrl}${note.img}`}
                                                        className="userImg me-3 "
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="d-flex">
                                                    <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                        <div className=" d-flex justify-content-between ">
                                                            <div>
                                                                <p className="text-muted cursor-pointer">
                                                                    <h6 className="d-inline me-2">
                                                                        By {note.name}
                                                                    </h6>{" "}

                                                                    {moment(note.created_at).format(
                                                                        "DD-MM-YYYY hh:mm:ss"
                                                                    )}
                                                                    <span className="pl-15">
                                                                        Got in touch with this lead at{" "}
                                                                        {moment(note.date).format('dddd')}{" "}
                                                                        {moment(note.date).format(
                                                                            "DD-MM-YYYY hh:mm a"
                                                                        )}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <i className="bi bi-triangle-fill note-icon"></i>
                                                        <div
                                                            className="Features"
                                                            dangerouslySetInnerHTML={{
                                                                __html: note.description,
                                                            }}
                                                        />
                                                        <p className="mb-2">
                                                            Amount : {note.currency_symbol} {note.amount}{" "}
                                                        </p>
                                                        {/* Following code is for Static Video File */}
                                                        <p className="mb-1">
                                                            Attachment :{" "}
                                                            <a
                                                                target="_blank "
                                                                className="btn btn-sm edit-delete-btn text-danger ml-10"
                                                                rel="noreferrer"
                                                                type="button"
                                                                href={"https://www.youtube-nocookie.com/embed/3S4fl7rpu3g?autoplay=0"}
                                                            // onClick={() =>
                                                            //   downloadImage({ imagelink: note.link })
                                                            // }
                                                            >
                                                                <i className="bi bi-record-circle recording-blink"></i> Open
                                                            </a>
                                                        </p>

                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                                {datas?.length == 0 ? (
                                    <p>Note is Not Addded</p>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body ">
                            <div className="responsive-table">
                                <div className="mb-4">
                                    <div className="d-flex justify-content-between">
                                        <h5 className="mb-3">Allocate Scope Hours</h5>
                                    </div>
                                    {projectDetail?.project_scope?.map((obj, i) => {
                                        return (
                                            <div className="row align-items-center mt-2" key={i}>
                                                <div className="col-md-12">
                                                    <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                    <span className="mb-0 text-purple fs-6">{obj}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div >
    )
}

export default OverviewOnboarding
